import React from "react";
import { observer } from "mobx-react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  withStyles
} from "@material-ui/core";
import { ArrowRight } from "mdi-material-ui";
import locale from "@bonliva-crm/locale";
import { Classes, ThemeType } from "@theme";
import { RegularButton, PrimaryButton, SpinnerOverlay } from "@components";
import {
  ContactListItemFragment,
  FetchContacts,
  ContactSelectorStore
} from "./ContactSelectorStore";
import { ContactList } from "../MassContactActions/components/ContactList";

export { ContactListItemFragment as Contact };

type Props = {
  classes: Classes<typeof styles>;
  allowEmpty?: boolean;
  open: boolean;
  onSubmit: (items: ContactListItemFragment[]) => void;
  onClose: () => void;
  onFetch: FetchContacts;
};

@observer
class ContactSelectorDialogBase extends React.Component<Props> {
  store = new ContactSelectorStore(this.props.onFetch);

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.open && !prevProps.open) {
      this.store.fetch();
    }
  }

  onCloseHandler = () => {
    this.props.onClose();
  };

  get canSubmit() {
    return this.props.allowEmpty || this.store.selectedIds.length;
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.onCloseHandler}
        TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
        fullWidth
        maxWidth={"md"}
        scroll="body"
      >
        <SpinnerOverlay show={this.store.isLoading} size={20} />

        <DialogTitle style={{ padding: "8px 0 0", textAlign: "center" }}>
          {locale.SelectContacts}
        </DialogTitle>

        <DialogContent>
          <ContactList
            columns={["CellPhone", "Email", "Role", "Title"]}
            items={this.store.items}
            selectedIds={this.store.selectedIds}
            onSelect={(item) => this.store.toggleItem(item._id)}
            onSelectAll={this.store.toggleAll}
            isSelectAllDisabled={this.store.items.length === 0}
            isAllSelected={this.store.selectedIds.length === this.store.items.length}
            dropdownCheckboxOptions={[]}
          />

          {this.props.allowEmpty && (
            <Typography variant="subtitle1" align="center" style={{ marginTop: 16 }}>
              You can add extra recipients at the next step
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <RegularButton onClick={this.onCloseHandler} variant="text">
            {locale.Cancel}
          </RegularButton>

          <PrimaryButton
            disabled={!this.canSubmit}
            rightIcon={<ArrowRight />}
            onClick={() => {
              this.props.onSubmit(this.store.selectedItems);
              setTimeout(this.store.reset, 500); // setTimeout so it doesn't flicker while animation is going
            }}
            className={classes.button}
            variant="text"
          >
            {locale.Next}
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme: ThemeType) => ({
  preview: {
    border: "1px solid #ccc",
    marginTop: 20
  },
  button: {
    margin: "0 4px"
  },
  list: {
    background: "#fff",
    zIndex: 2,
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    padding: theme.spacing(2)
  },
  btnWrp: {
    padding: theme.spacing(),
    textAlign: "right"
  }
});

export const ContactSelectorDialog = withStyles(styles as any)(ContactSelectorDialogBase);
